import request from '../../../api/request';
import {
  CalendarResponse,
  CreateClassroomEventDto,
} from './ClassroomCalendar/types';
import {
  ClassroomResponseType,
  Classroom,
  ClassroomFormData,
  ClassroomFormRequest,
  ClassroomsFilterData,
  ClassroomsLoaderQuery,
} from './types';

const CLASSROOMS_ENDPOINTS = {
  LIST: 'maintainers-portal/classroom',
  FORM: 'maintainers-portal/classroom/form',
  CREATE: 'maintainers-portal/classroom',
  UPDATE: (id: number) => `maintainers-portal/classroom/${id}`,
  DELETE: (id: number) => `maintainers-portal/classroom/${id}`,
  TOGGLE_STATUS: (id: number) =>
    `maintainers-portal/classroom/${id}/toggle-status`,
  FILTERS_DATA: 'maintainers-portal/classroom/filters-data',
  CALENDAR: (id: number | string) =>
    `maintainers-portal/classroom/${id}/calendar`,
  CREATE_EVENT: (id: number | string) =>
    `maintainers-portal/classroom/${id}/classroom-event`,
  EVENT_TYPES: 'maintainers-portal/classroom/classroom-event/types',
};

export async function getClassrooms(query: ClassroomsLoaderQuery) {
  const { items, ...rest } = query;
  return request<ClassroomResponseType>(CLASSROOMS_ENDPOINTS.LIST, {
    method: 'GET',
    params: {
      ...rest,
      items_per_page: items,
    },
  });
}

export const getFormData = () => {
  return request<ClassroomFormData>(CLASSROOMS_ENDPOINTS.FORM);
};

export const create = (data: ClassroomFormRequest) => {
  return request<Classroom>(CLASSROOMS_ENDPOINTS.CREATE, {
    method: 'POST',
    data,
  });
};

export const update = (id: number, data: ClassroomFormRequest) => {
  return request<Classroom>(CLASSROOMS_ENDPOINTS.UPDATE(id), {
    method: 'PUT',
    data,
  });
};

export const remove = (id: number) => {
  return request<void>(CLASSROOMS_ENDPOINTS.DELETE(id), {
    method: 'DELETE',
  });
};

export async function getFiltersData() {
  return request<ClassroomsFilterData>(CLASSROOMS_ENDPOINTS.FILTERS_DATA, {
    method: 'GET',
  });
}
export const getClassroomCalendar = (id: number | string) => {
  return request<CalendarResponse>(CLASSROOMS_ENDPOINTS.CALENDAR(id));
};

export const toggleStatus = (id: number, isEnabled: boolean) => {
  return request<Classroom>(CLASSROOMS_ENDPOINTS.TOGGLE_STATUS(id), {
    method: 'PUT',
    data: { isEnabled },
  });
};

export const createClassroomEvent = (data: CreateClassroomEventDto) => {
  return request<void>(CLASSROOMS_ENDPOINTS.CREATE_EVENT(data.classroomId), {
    method: 'POST',
    data,
  });
};

export const getClassroomEventTypes = () => {
  return request<{ id: number; name: string }[]>(
    CLASSROOMS_ENDPOINTS.EVENT_TYPES,
    {
      method: 'GET',
    },
  );
};
